import { render, staticRenderFns } from "./purchaseApplyManageList.vue?vue&type=template&id=221c8cf8&scoped=true"
import script from "./purchaseApplyManageList.vue?vue&type=script&lang=js"
export * from "./purchaseApplyManageList.vue?vue&type=script&lang=js"
import style0 from "./purchaseApplyManageList.vue?vue&type=style&index=0&id=221c8cf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221c8cf8",
  null
  
)

export default component.exports